module.exports = __webpack_public_path__ + "static/media/Frame-1.d4f06d1d.jpg";